import React, { useEffect, useState } from 'react';
import './Login.scss';
import { toast } from 'react-toastify';
import { loginAdmin } from '../../services/adminService';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../redux/slice/userSlice';
import { toAuthState } from '../../dto/auth.dto';
import { Button } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Login = (props) => {
    const admin = useSelector(state => state.admin || state.user);
    const dispatch = useDispatch();
    let navigate = useNavigate();

    const [adminCode, setAdminCode] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isValidAdminCode, setIsValidAdminCode] = useState(true);
    const [isValidPassword, setIsValidPassword] = useState(true);
    const [loading, setLoading] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleLogin = async (e) => {
        if (e) e.preventDefault();
        setIsValidAdminCode(true);
        setIsValidPassword(true);

        if (!adminCode || !password) {
            toast.error('Vui lòng nhập đầy đủ Mã quản trị viên và Mật khẩu');
            if (!adminCode) setIsValidAdminCode(false);
            if (!password) setIsValidPassword(false);
            return;
        }

        setLoading(true);
        try {
            let response = await loginAdmin(adminCode, password);

            const authState = toAuthState(response, 'admin');
            if (authState) {
                toast.success(response.message || response.message || 'Đăng nhập thành công!');
                dispatch(login(authState));
                navigate('/');
            } else {
                toast.error(response?.error?.message || response?.message || 'Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin.');
            }
        } catch (error) {
            console.error('Error in admin login: ', error);
            toast.error('Có lỗi xảy ra trong quá trình đăng nhập');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (admin && admin.isAuthenticated) {
            navigate('/');
        }
    }, [admin, navigate]);

    return (
        <div className="admin-login-page">
            <div className="admin-login-card shadow-lg">
                <div className="text-center mb-4">
                    <div className="admin-icon-badge mb-3">
                        <i className="bi bi-shield-check text-primary fs-1"></i>
                    </div>
                    <h3 className="fw-extrabold text-dark mb-1">ĐĂNG NHẬP QUẢN TRỊ</h3>
                    <div className="portal-tag mt-2">
                        <i className="bi bi-building-gear me-1"></i>
                        <span>Cổng Quản Lý Bãi Đỗ IUH Parking</span>
                    </div>
                </div>

                <form onSubmit={handleLogin}>
                    <div className="form-group mb-3">
                        <label className="form-label text-secondary fw-semibold small">Mã quản trị viên:</label>
                        <div className="input-group-custom">
                            <i className="bi bi-person-badge input-icon"></i>
                            <input
                                type="text"
                                placeholder="Nhập mã quản trị viên..."
                                value={adminCode}
                                onChange={(e) => setAdminCode(e.target.value)}
                                className={`form-control ${isValidAdminCode ? '' : 'is-invalid'}`}
                            />
                        </div>
                        {!isValidAdminCode && (
                            <span className="error-text">Vui lòng nhập mã quản trị viên</span>
                        )}
                    </div>

                    <div className="form-group mb-4">
                        <label className="form-label text-secondary fw-semibold small">Mật khẩu hệ thống:</label>
                        <div className="input-group-custom">
                            <i className="bi bi-lock input-icon"></i>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className={`form-control ${isValidPassword ? '' : 'is-invalid'}`}
                                placeholder="Nhập mật khẩu..."
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {!isValidPassword && (
                            <span className="error-text">Vui lòng nhập mật khẩu</span>
                        )}
                    </div>

                    <Button
                        type="submit"
                        disabled={loading}
                        className="btn-admin-login-submit w-100 py-3 rounded-3 fw-bold"
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Đang xác thực...
                            </>
                        ) : (
                            <>
                                <i className="bi bi-box-arrow-in-right me-2 fs-5"></i>
                                ĐĂNG NHẬP VÀO HỆ THỐNG
                            </>
                        )}
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default Login;